import { pick } from 'lodash'

import { Action } from 'redux/actions'
import { NAVIGATION_STORAGE_KEY } from 'redux/constants'
import { setLocalStorage } from 'utils/localStorage'
import { NavSortOrder, RootState } from 'types'

const STORED_ATTRIBUTES = ['hideLeftNavRail', 'preferredSort']

const storeNavigationState = (state: RootState['navigation']) => {
  setLocalStorage(NAVIGATION_STORAGE_KEY, pick(state, STORED_ATTRIBUTES))
  return state
}

export const defaultState = {
  hideLeftNavRail: false,
  openWorkspaceDropdown: false,
  everyoneDocIds: [],
  privateDocIds: [],
  preferredSort: NavSortOrder.NameAsc,
}

const reduce = (state: RootState['navigation'] = defaultState, action: Action): RootState['navigation'] => {
  switch (action.type) {
    case 'NAVIGATION_HIDE_LEFT_RAIL': {
      return storeNavigationState({ ...state, ...action.payload })
    }
    case 'NAVIGATION_SET_PREFERRED_SORT': {
      return storeNavigationState({ ...state, ...action.payload })
    }
    case 'NAVIGATION_WORKSPACE_DROPDOWN_OPEN': {
      return { ...state, openWorkspaceDropdown: action.payload }
    }
    default:
      return state
  }
}

export default reduce
